/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';

export const FONT_WEIGHT_NAMES = {
  100: _x('Thin', 'font weight', 'web-stories'),
  200: _x('Extra-light', 'font weight', 'web-stories'),
  300: _x('Light', 'font weight', 'web-stories'),
  400: _x('Regular', 'font weight', 'web-stories'),
  500: _x('Medium', 'font weight', 'web-stories'),
  600: _x('Semi-bold', 'font weight', 'web-stories'),
  700: _x('Bold', 'font weight', 'web-stories'),
  800: _x('Extra-bold', 'font weight', 'web-stories'),
  900: _x('Black', 'font weight', 'web-stories'),
};
